import { useQuery } from "react-query";

export const useSmartQuery = (
  queryKey,
  queryFn,
  { enabled = true, condition = true, onSuccess, onError, zustandSetter, ...rest } = {}
) => {
  return useQuery(queryKey, queryFn, {
    enabled: enabled && condition,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      zustandSetter?.(data);
      onSuccess?.(data);
    },
    onError: (error) => {
      console.error("SmartQuery Error:", error);
      onError?.(error);
    },
    ...rest,
  });
};
